import ConversacionesGlobalesLayer from "../../components/conversacionesGlobales/ConversacionesGlobalesLayer";

const ConversacionesGlobalesPage = () => {
  return <ConversacionesGlobalesLayer />;
};

export default ConversacionesGlobalesPage;
